import { useQuery } from '@tanstack/react-query';
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

const fetchCourseOverview = async (courseId) => {
  const url = `${getConfig().LMS_BASE_URL}/api/courses/v1/courses/${encodeURIComponent(courseId)}`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

export const useCourseOverview = (courseId) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['courseOverview', courseId],
    queryFn: () => fetchCourseOverview(courseId),
    enabled: Boolean(courseId),
    staleTime: 10 * 60 * 1000,
  });

  return {
    overview: data || null,
    loading: isLoading,
    error,
  };
};
